import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findProductOffline({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`productOffline/findProductOffline`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findProduct({ commit }, params) {
	return new Promise((resolve, reject) => {
		axios.post(`productOffline/findProduct`, params)
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
  },
  addProductOffline({ commit }, params) {
	return new Promise((resolve, reject) => {
		axios.post(`productOffline/addProductOffline`, params)
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
  },
  deleteProductOffline({ commit }, params) {
	return new Promise((resolve, reject) => {
		axios.post(`productOffline/deleteProductOffline`, params)
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`productOffline/findById`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  saveProductOffline({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`productOffline/saveProductOffline`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
	},
}
